export interface RequirementType {
    type: string;
    value: string;
    title: string;
    formType: 'genericResponse' | 'genericUpload' | 'confirmSignature';
    private: boolean;
    additional_instructions: string;
}

const data: RequirementType[] = [
    {
        type: 'photoIdUpload',
        value: 'Upload File - Photo ID',
        title: "Photo of Driver's License/ID",
        formType: 'genericUpload',
        private: false,
        additional_instructions: 'Please upload clear images of the front and back of your ID',
    },
    {
        type: 'MedicalResultsUpload',
        value: 'Upload File - Medical Results',
        title: 'Medical Assessment Results',
        formType: 'genericUpload',
        private: true,
        additional_instructions: 'Please upload a copy of your medical assessment results',
    },
    {
        type: 'MedicalVisitResponse',
        value: 'Recent Medical Visit',
        title: 'Describe Your Last Medical Visit and its Outcome',
        formType: 'genericResponse',
        private: true,
        additional_instructions: 'Please provide the date of your last medical visit, its reason, and its outcome',
    },
    {
        type: 'ParamedicalExamAvailabilityResponse',
        value: 'Indicate Availability - Paramedical Exam',
        title: 'Confirm Availability: Paramedical Exam',
        formType: 'genericResponse',
        private: false,
        additional_instructions:
            'A paramedical exam is required for your application. Indicate your availability below, and we will schedule an exam on your behalf',
    },
    {
        type: 'PrescriptionDetailsResponse',
        value: 'Prescription Details',
        title: 'Recent Prescription Details',
        formType: 'genericResponse',
        private: true,
        additional_instructions:
            'Please let us know what prescriptions you are taking now, and what you have taken in the past three months',
    },
    {
        type: 'LastSubstanceUsageResponse',
        value: 'Last Substance Usage',
        title: 'Last Usage of [Substance]',
        formType: 'genericResponse',
        private: true,
        additional_instructions:
            'Please let us know what substances you are using now, and what you have using in the past three months',
    },
    {
        type: 'TobaccoUseDetailsResponse',
        value: 'Tobacco Use Details',
        title: 'Details Regarding Recent Tobacco Usage',
        formType: 'genericResponse',
        private: true,
        additional_instructions:
            'Please let us know what tobacco products you are using now, and what you have used in the past three months',
    },
    {
        type: 'BankruptcyDetailsResponse',
        value: 'Bankruptcy Details',
        title: 'Details Regarding Bankruptcy',
        formType: 'genericResponse',
        private: true,
        additional_instructions: 'Please provide details regarding your bankruptcy filing',
    },
    {
        type: 'OtherInsuranceActivityResponse',
        value: 'Other Insurance Activity',
        title: 'Details Regarding Other Insurance Activity',
        formType: 'genericResponse',
        private: true,
        additional_instructions:
            'If you have applied for other insurance in the past three months, please provide details below',
    },
    {
        type: 'SourceOfIncomeResponse',
        value: 'Source of Income',
        title: 'Describe the Source of Your Income',
        formType: 'genericResponse',
        private: true,
        additional_instructions: 'Please provide details regarding the source of your income below',
    },
    {
        type: 'PriorEmploymentDetailsResponse',
        value: 'Prior Employment Details',
        title: 'Prior Occupation Details',
        formType: 'genericResponse',
        private: true,
        additional_instructions: 'Please provide details regarding your previous occupations within the past year',
    },
    {
        type: 'CriminalHistoryDetailsResponse',
        value: 'Criminal History Details',
        title: 'Criminal History Details',
        formType: 'genericResponse',
        private: true,
        additional_instructions:
            'Please provide details regarding your previous criminal convictions including conviction and date',
    },
    {
        type: 'BloodGlucoseReadingResponse',
        value: 'Blood Glucose Reading',
        title: 'Blood Glucose Reading',
        formType: 'genericResponse',
        private: true,
        additional_instructions: 'Please provide details regarding your A1C blood glucose reading',
    },
    {
        type: 'VerifyHeightWeightResponse',
        value: 'Verify Height/Weight',
        title: 'Verify Correct Height and Weight',
        formType: 'genericResponse',
        private: true,
        additional_instructions: 'Please verify your correct height and weight',
    },
    {
        type: 'CovidTestingDetailsResponse',
        value: 'COVID Testing Details',
        title: 'COVID Testing Details',
        formType: 'genericResponse',
        private: true,
        additional_instructions:
            'Please provide details about your COVID testing including symptoms, date of test, and result',
    },
    {
        type: 'genericResponse',
        value: 'Generic Response',
        title: 'Generic Response',
        formType: 'genericResponse',
        private: true,
        additional_instructions: '',
    },
    {
        type: 'genericUpload',
        value: 'Generic Upload',
        title: 'Generic Upload',
        formType: 'genericUpload',
        private: true,
        additional_instructions: '',
    },
    {
        type: 'confirmSignature',
        value: 'Confirm Signature',
        title: 'Confirm Signature',
        formType: 'confirmSignature',
        private: true,
        additional_instructions: '',
    },
    {
        type: 'primaryCareProvider',
        value: 'Primary Care Provider',
        title: 'Primary Care Provider',
        formType: 'genericResponse',
        private: true,
        additional_instructions: '',
    },
    {
        type: 'employmentInfo',
        value: 'Employment Verification',
        title: 'Employment Verification',
        formType: 'genericResponse',
        private: true,
        additional_instructions: '',
    },
    {
        type: 'familyHistoryFather',
        value: 'Father History',
        title: 'Father History',
        formType: 'genericResponse',
        private: true,
        additional_instructions: '',
    },
    {
        type: 'familyHistoryMother',
        value: 'Mother History',
        title: 'Mother History',
        formType: 'genericResponse',
        private: true,
        additional_instructions: '',
    },
];

data.sort((a: RequirementType, b: RequirementType) => a.value.localeCompare(b.value));
export default data;
